import axios from 'axios';
import { ImportVideoDataInterface } from '../../../type/videoSourceType';

export type VideoSourcePreviewHandlersProps = {
  setLoading: (loading: boolean) => void;
  setModalTitle: (title: string) => void;
  setModalVisible: (visible: boolean) => void;
  setImportVideoDataList: (list: ImportVideoDataInterface[]) => void;
};

export type VideoSourcePreviewHandlersReturn = {
  handleOnClickPreviewButton: (url: string, name: string) => void;
  handleCloseModal: () => void;
};

export const getVideoSourcePreviewHandlers = ({
  setLoading,
  setModalTitle,
  setModalVisible,
  setImportVideoDataList,
}: VideoSourcePreviewHandlersProps): VideoSourcePreviewHandlersReturn => {
  const handleOnClickPreviewButton = async (url: string, name: string): Promise<void> => {
    try {
      setLoading(true); // Start loading
      const response = await axios.get(url);
      const mrssData = response.data;

      // XML parsing logic (add as needed)
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(mrssData, 'text/xml');
      const items = xmlDoc.getElementsByTagName('item');

      const videoItems = [];
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const title = item.getElementsByTagName('media:title')[0]?.textContent || 'No Title';
        const pubDate = item.getElementsByTagName('pubDate')[0]?.textContent || 'No Date';
        const thumbnailUrl =
          item.getElementsByTagName('media:thumbnail')[0]?.getAttribute('url') || '';
        const contentUrl = item.getElementsByTagName('media:content')[0]?.getAttribute('url') || '';
        const duration =
          item.getElementsByTagName('media:content')[0]?.getAttribute('duration') || '0';

        videoItems.push({
          key: i.toString(),
          title,
          pubDate,
          thumbnailUrl,
          contentUrl,
          duration,
        });
      }

      setImportVideoDataList(videoItems); // Set video data
      setModalTitle(name); // Set modal title
      setModalVisible(true); // Open modal
    } catch (error) {
      console.error('Error fetching video data:', error);
    } finally {
      setLoading(false); // End loading
    }
  };

  const handleCloseModal = (): void => {
    setModalVisible(false);
    setImportVideoDataList([]); // Reset video data
  };

  return {
    handleOnClickPreviewButton,
    handleCloseModal,
  };
};
